import { Component, OnInit, Input, Injectable, Inject, ViewChild, Output } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { Subject } from 'rxjs/Subject';
import { MatPaginatorIntl } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Http, Headers, Response } from '@angular/http';
import { SecurityService } from '../security.service';

import 'rxjs/add/operator/toPromise';
import { EnvironmentProvider } from '../../core/browser-providers';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { Environment } from '../../../environments/enviroment.model';
import { TranslateService } from '../../core/translate.service';
import { UpdateEventService } from '../../shared-services/update-event.service';
import { User } from './user.model';
import { MediaService } from '../../shared-services/media.service';
import { Subscription } from 'rxjs/Subscription';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { SearchInputComponent } from '../../shared-components/search-input/search-input.component';

interface Filters {
  name: string;
  page: number;
  size: number;
  email?: string;
  search?: string;
}

interface Page {
  pageIndex: number;
  pageSize: number;
}

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
@Injectable()
export class UserListComponent implements OnInit {

  // @Output() subtitle = 'Listado';

  private backendUrl: string;

  private filters: Filters = {
    name: undefined,
    page: 0,
    size: 10,
  };

  columns = [
    { name: 'username',  label: 'Nombre de usuario' },
    { name: 'nombre',  label: 'Nombre' },
    { name: 'apellidos',  label: 'Apellido' },
    { name: 'tipo_documento',  label: 'Tipo de Documento' },
    { name: 'nroDocumento',  label: 'Numero de Documento' },
    { name: 'f_ultimo_login',  label: 'Último ingreso' },
    { name: 'habilitado', label: 'Habilitado' }
  ];

  public showFilters = true;
  isMobile: boolean;

  @ViewChild(SearchInputComponent)
  private searchComponent: SearchInputComponent;

  private getNewPage = new Subject<Filters>();

  public totalItems: number;

  roleFiltersActive = false;
  mostrarResumen = false;
  isLoading = false;

  filtersLoaded = false;
  subscriptions: Subscription[] = [];

  usersList = this.backendService.newSubjectWithoutDistinct<Filters>()
  .switchMap(filters => {
    const usersPromise = this.backendService.get(User, User.path, filters).toPromise();
    return (async () => {
      this.isLoading = true;
      try {
        const permissions = await usersPromise;
        return permissions;
      } catch (error) {
        return [];
      }
      finally {
        this.isLoading = false;
        this.roleFiltersActive = !(this.filters.search === '' || this.filters.search === undefined);
      }
    })();
  }).share() as Observer<Filters> & Observable<User[]>;

  constructor(
    @Inject(EnvironmentProvider) env: Environment,
    private route: ActivatedRoute,
    private backendService: BackendService,
    private paginatorsLabels: MatPaginatorIntl,
    private snackService: SnackService,
    private traslateService: TranslateService,
    public router: Router,
    protected updateEventService: UpdateEventService,
    private mediaService: MediaService,
    private http: Http,
    public securityService: SecurityService,
    private dialogService: DialogService,
  ) {
    this.backendUrl = env.endpoints.api + '/backend';
  }

  ngOnInit() {
    this.showFilters = true;
    this.filtersLoaded = true;

    this.subscriptions.push(this.mediaService.isMobile.subscribe(isMobile => {
      this.isMobile = isMobile;
      this.showFilters = !this.isMobile;
    }));

    this.paginatorsLabels.itemsPerPageLabel = 'Filas por página:';

    this.usersList.subscribe(t => {
      this.isLoading = false;
      this.totalItems = t['totalItems'];
    });

    this.refreshRoleList();
  }


  refreshRoleList() {
    this.usersList.next(this.getFilters());
  }

  getDefaultFilters() {
    this.filters = {
      name : undefined,
      page: 0,
      size: 10,
    };
  }

  getFilters() {
    return this.filters;
  }

  // Seteo de filtros
  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
    this.refreshRoleList();
  }

  onSearch(searchText) {
    this.filters.search = 'name:' + searchText;
    this.refreshRoleList();
  }

  clearSearch() {
    this.searchComponent.searchBox.value = '';
    this.refreshRoleList();
  }

  getData(response: Response) {
    const data = response.json();
    if (response.ok) { return data; }
    throw data['hydra:description'] || data['message'];
  }

  displayFilters(boolean: boolean) {
    this.showFilters = boolean;
  }

  onAddUser() {
    this.router.navigate(['/usuarios/agregar']);
  }

  onChangePassword(user: User) {
    this.router.navigate(['/usuarios/cambiar_password', user.id]);
  }

  async onResetPassword(user: User) {

    this.dialogService.confirm('Reestablecer contraseña',
    '¿Está seguro que desea reestablecer la contraseña del Usuario ' + user.username + '?')
    .then( res => {
      if (res) {
        this.resetPassword(res, user);
      }
    });

  }

  onEditUser(user: User) {
    this.router.navigate(['/usuarios/editar', user.id]);
  }

  async onDeleteUser(user: User) {

    this.dialogService.confirm('Eliminar Usuario',
    '¿Está seguro que desea eliminar el Usuario ' + user.username + '?')
    .then( res => {
      if (res) {
        this.deleteUser(res, user);
      }
    });

  }

  async onHabilitar(user: User) {

    this.dialogService.confirm('Habilitar Usuario',
    '¿Está seguro que desea habilitar al Usuario ' + user.username + '?')
    .then( res => {
      if (res) {
        this.enableUser(res, user);
      }
    });

  }

  async enableUser(res, user: User) {

    if (res) {

      this.snackService.spinner(true);

      try {
        const ruta = User.path + 'habilitar/' + user.id;
        await this.backendService.enable(User.path + 'habilitar/' + user.id);
        this.snackService.success('Usuario habilitado correctamente');
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
        this.refreshRoleList();
      }

    }

  }

  async onInhabilitar(user: User) {

    this.dialogService.confirm('Inhabilitar Usuario',
    '¿Está seguro que desea inhabiliar al Usuario ' + user.username + '?')
    .then( res => {
      if (res) {
        this.disableUser(res, user);
      }
    });

  }

  async disableUser(res, user: User) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.disable(User.path + 'inhabilitar/' + user.id);
        this.snackService.success('Usuario inhabilitado correctamente');
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
        this.refreshRoleList();
      }

    }

  }

  async deleteUser(res, user: User) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.delete(User.path + user.id);
        this.snackService.success('Usuario eliminado correctamente');
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
        this.refreshRoleList();
      }

    }

  }

  async resetPassword(res, user: User) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.resetPassword('/usuarios_internos/reset_password?id=' + user.id, User);
        this.snackService.success('Contraseña reestablecida correctamente');
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
        this.refreshRoleList();
      }

    }

  }

  onFiltersChanged(event) {
    this.refreshRoleList();
  }

  removeChip(event) {
    this.refreshRoleList();
  }

}



// WEBPACK FOOTER //
// ./src/app/security/user/user-list.component.ts